import { BsBuilding } from "react-icons/bs";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { SguUnitsSideMenu, SguUnitMenuItem } from "../../../components/SguUnitsMenu";

const textoLimitado = (texto, limite = 30) => {
  if (!texto) return "";
  return texto.length <= limite ? texto : `${texto.slice(0, limite)}...`;
};

const getAlrmCount = (unit) => {
  const arr = Array.isArray(unit?.otherEquipments) ? unit.otherEquipments : [];
  return arr.filter((e) => e.serialNumber?.toUpperCase().includes("ALRM")).length;
};

const NotificationMenu = ({
  user,
  units,
  onUnitSelect,
  onSearch,
  selectedUnit,
  searchValue,
  headerRight,
}) => (
  <SguUnitsSideMenu
    icon={BsBuilding}
    subtitle="Seleção"
    title="Unidades"
    headerRight={headerRight}
    sectionId="alarm-unidades"
    searchValue={searchValue}
    onSearch={onSearch}
    emptyText="Nenhuma unidade com alarme encontrada"
  >
    {(units || []).map((unit) => {
      const alrmCount = getAlrmCount(unit);
      return (
        <SguUnitMenuItem
          key={unit._id || unit.cnpj}
          active={selectedUnit?._id === unit._id}
          title={
            user?.hideSensitiveInfo
              ? "*****"
              : textoLimitado(unit.name?.toUpperCase() || "Empresa sem nome", 30)
          }
          badge={
            <>
              <HiOutlineExclamationCircle size={12} className="me-1" />
              {alrmCount} {alrmCount === 1 ? "alarme" : "alarmes"}
            </>
          }
          meta={user?.hideSensitiveInfo ? "*****" : unit?.address || "--"}
          onClick={() => onUnitSelect(unit)}
        />
      );
    })}
  </SguUnitsSideMenu>
);

export default NotificationMenu;
